class AddResponseHandler {
  static sendGTMErrorEvent(eventName, eventData) {
    try {
      if (typeof window.dataLayer !== 'undefined') {
        window.dataLayer.push({
          event: eventName,
          ...eventData
        });
      }

      if (typeof window.gtag !== 'undefined') {
        window.gtag('event', eventName, {
          custom_parameters: eventData
        });
      }
    } catch (error) {
      console.error('Error sending GTM event:', error);
    }
  }

  static handleCartAddError(updates, response = null, data = null, error = null, operationType = 'single_add') {
    const eventName = 'cart_add_error';
    
    const addIntendProducts = window.predictProduct?.id || null;
    
    const time = Date.now();

    let errorMessage = '';
    if (response && !response.ok) {
      errorMessage = data?.description || data?.error || JSON.stringify(data);
      this.sendGTMErrorEvent(eventName, {
        add_payload: updates,
        error_response: errorMessage,
        status_code: response.status,
        status_text: response.statusText,
        operation_type: operationType,
        add_intend_products: addIntendProducts,
        time: time
      });
    } else if (error) {
      errorMessage = error?.description || error?.message || 'Unknown error occurred';
      this.sendGTMErrorEvent(eventName, {
        add_payload: updates,
        error_response: errorMessage,
        error_type: 'network_error',
        operation_type: operationType,
        add_intend_products: addIntendProducts,
        time: time
      });
    }

    this.showErrorInHTML(errorMessage);
  }

  static showErrorInHTML(errorMessage) {
    const errorContainers = document.querySelectorAll('.addtocart-error');
    
    if (errorContainers.length > 0 && errorMessage) {
      errorContainers.forEach(errorContainer => {
        const errorSpan = document.createElement('span');
        errorSpan.textContent = errorMessage;
        errorSpan.style.color = 'red';
        errorSpan.style.display = 'block';
        errorSpan.style.marginTop = '5px';
        errorSpan.style.transition = 'opacity 0.5s ease-out';
        errorSpan.style.opacity = '1';
        
        errorContainer.parentNode.insertBefore(errorSpan, errorContainer.nextSibling);
        
        setTimeout(() => {
          if (errorSpan.parentNode) {
            errorSpan.style.opacity = '0';
            setTimeout(() => {
              if (errorSpan.parentNode) {
                errorSpan.parentNode.removeChild(errorSpan);
              }
            }, 500);
          }
        }, 5000);
      });
    }
  }
}

window.AddResponseHandler = AddResponseHandler;